import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

const StyledDiv = styled.div`
  text-align: center;
  img {
    height: 25px;
    margin-right: ${SPACERS.tiny};
  }
  .powered-by-text {
    font-size: 10px;
  }
`;

const PoweredByLogo: React.FC<{
  className?: string;
}> = ({ className }) => {
  return (
    <StyledDiv className={className}>
      <div>
        <img
          draggable={false}
          src="/images/svg/logo_primary.svg"
          alt="Powered by True Impact"
          className="powered-by-logo"
        />
        <TrueImpactText variant="body-small" className="powered-by-text">
          Powered by True Impact
        </TrueImpactText>
      </div>
    </StyledDiv>
  );
};

export default PoweredByLogo;
